import TagManager from 'react-gtm-module';
import services from 'services/services';

// Import variables
import { TRACKING_TYPES } from '../variables';
const { GTM } = TRACKING_TYPES;

const validKeyRegex = new RegExp(/GTM-[A-Z0-9]{7}/, 'g');
// GTM-XXXXXXX

export const initGTM = async () => {
	try {
		const {
			data: { value }
		} = await services.get(`/settings/codes/${GTM}`);
		if (value && validKeyRegex.exec(value)) {
			TagManager.initialize({
				gtmId: value
			});
		} else
			console.warn(
				`Provided ${GTM} key is invalid or missing, check your CMS settings`
			);
	} catch {
		console.error(`Could not fetch your ${GTM} key`);
	}
};

export const sendGTMEvent = ({ event, customEventData }) => {
	TagManager.dataLayer({ dataLayer: { ced: null } });

	const modifiedGTMData = modifyGTMData(customEventData);

	TagManager.dataLayer({
		dataLayer: { event, ced: modifiedGTMData }
	});
};

const modifyGTMData = (customEventData) => {
	const { genres, page_url, url: redirectData } = customEventData;

	// Add app website core path to path related keys
	const websiteUrl = process.env.REACT_APP_WEBSITE_URL.replace(/\/$/, '');
	if (page_url) {
		customEventData.page_url = `${websiteUrl}${page_url}`;
	}
	if (redirectData) {
		const { url, isExternal } = redirectData;
		customEventData.url = isExternal ? url : `${websiteUrl}${url}`;
	}

	// Genres refactor to separate key - value pairs
	if (genres) {
		genres.forEach((genre, index) => {
			customEventData[`item_category${index + 1}`] = genre.name;
		});
		delete customEventData.genres;
	}

	return customEventData;
};
